
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("lq4sa"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("lq4sa", function(module, exports) {

let $f97f7affcd08efa7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f97f7affcd08efa7$var$load("5wVuh"),
    $f97f7affcd08efa7$var$load("4NznW"),
    $f97f7affcd08efa7$var$load("1F7LX"),
    $f97f7affcd08efa7$var$load("jZLnv"),
    $f97f7affcd08efa7$var$load("6edij"),
    $f97f7affcd08efa7$var$load("gknbb"),
    $f97f7affcd08efa7$var$load("6iz6l"),
    $f97f7affcd08efa7$var$load("4SCW2"),
    $f97f7affcd08efa7$var$load("36QeB"),
    $f97f7affcd08efa7$var$load("9q75n"),
    $f97f7affcd08efa7$var$load("iYHbd"),
    $f97f7affcd08efa7$var$load("cHb2G"),
    $f97f7affcd08efa7$var$load("3q2Ng"),
    $f97f7affcd08efa7$var$load("jRpDi"),
    $f97f7affcd08efa7$var$load("hnGEQ"),
    $f97f7affcd08efa7$var$load("3GuOt"),
    $f97f7affcd08efa7$var$load("jbM5v"),
    $f97f7affcd08efa7$var$load("dek7I"),
    $f97f7affcd08efa7$var$load("dYtBN"),
    $f97f7affcd08efa7$var$load("kNV5Y"),
    $f97f7affcd08efa7$var$load("6SWFK"),
    $f97f7affcd08efa7$var$load("9aQIt"),
    $f97f7affcd08efa7$var$load("5zapo"),
    $f97f7affcd08efa7$var$load("3MYQs"),
    $f97f7affcd08efa7$var$load("XZauT"),
    $f97f7affcd08efa7$var$load("4S1SF"),
    $f97f7affcd08efa7$var$load("jiFtb"),
    $f97f7affcd08efa7$var$load("lm9Lt"),
    $f97f7affcd08efa7$var$load("9atVd"),
    $f97f7affcd08efa7$var$load("9wPDc"),
    $f97f7affcd08efa7$var$load("1MWOL"),
    $f97f7affcd08efa7$var$load("6fQco"),
    $f97f7affcd08efa7$var$load("aOY32"),
    $f97f7affcd08efa7$var$load("7jSfd"),
    $f97f7affcd08efa7$var$load("4HZlX"),
    $f97f7affcd08efa7$var$load("kDqHr"),
    $f97f7affcd08efa7$var$load("6wr18"),
    $f97f7affcd08efa7$var$load("gT8XU"),
    $f97f7affcd08efa7$var$load("53AGa"),
    $f97f7affcd08efa7$var$load("8bhm4"),
    $f97f7affcd08efa7$var$load("ffEVr"),
    $f97f7affcd08efa7$var$load("7EorR"),
    $f97f7affcd08efa7$var$load("8k9aB"),
    $f97f7affcd08efa7$var$load("fLwVm"),
    $f97f7affcd08efa7$var$load("kuFG2"),
    $f97f7affcd08efa7$var$load("hhss7"),
    $f97f7affcd08efa7$var$load("Wowvf"),
    $f97f7affcd08efa7$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("cqc9f"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("cqc9f", function(module, exports) {

let $90b15618f435f76f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90b15618f435f76f$var$load("6wr18"),
    $90b15618f435f76f$var$load("cHb2G"),
    $90b15618f435f76f$var$load("53AGa"),
    $90b15618f435f76f$var$load("8bhm4"),
    $90b15618f435f76f$var$load("ffEVr"),
    $90b15618f435f76f$var$load("cX4Bp"),
    $90b15618f435f76f$var$load("dawn8"),
    $90b15618f435f76f$var$load("hhss7"),
    $90b15618f435f76f$var$load("aQh37"),
    $90b15618f435f76f$var$load("bJVDE"),
    $90b15618f435f76f$var$load("8k9aB"),
    $90b15618f435f76f$var$load("fLwVm"),
    $90b15618f435f76f$var$load("kuFG2"),
    $90b15618f435f76f$var$load("1F7LX"),
    $90b15618f435f76f$var$load("3QXpo"),
    $90b15618f435f76f$var$load("h3ABO"),
    $90b15618f435f76f$var$load("kC80R"),
    $90b15618f435f76f$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("gnK2q"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("gnK2q", function(module, exports) {

let $bed2818307f017df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bed2818307f017df$var$load("j4FoV"),
    $bed2818307f017df$var$load("lRfiO"),
    $bed2818307f017df$var$load("fuks3"),
    $bed2818307f017df$var$load("b9CA3"),
    $bed2818307f017df$var$load("2YffH"),
    $bed2818307f017df$var$load("lUDr0"),
    $bed2818307f017df$var$load("8dwgS"),
    $bed2818307f017df$var$load("9XOeB"),
    $bed2818307f017df$var$load("xu7ej"),
    $bed2818307f017df$var$load("iQ4FP"),
    $bed2818307f017df$var$load("71gca"),
    $bed2818307f017df$var$load("emZDM"),
    $bed2818307f017df$var$load("82Jpo"),
    $bed2818307f017df$var$load("eXKRO"),
    $bed2818307f017df$var$load("im1VN"),
    $bed2818307f017df$var$load("6WAC7"),
    $bed2818307f017df$var$load("czOM6"),
    $bed2818307f017df$var$load("5yluq"),
    $bed2818307f017df$var$load("2tcSk"),
    $bed2818307f017df$var$load("8pLtn"),
    $bed2818307f017df$var$load("8auEH"),
    $bed2818307f017df$var$load("jAeEl"),
    $bed2818307f017df$var$load("lKs3T"),
    $bed2818307f017df$var$load("9anPW"),
    $bed2818307f017df$var$load("3EXzu"),
    $bed2818307f017df$var$load("b2FtX"),
    $bed2818307f017df$var$load("gnDXu"),
    $bed2818307f017df$var$load("dl2qY"),
    $bed2818307f017df$var$load("kL5FA"),
    $bed2818307f017df$var$load("6iz6l"),
    $bed2818307f017df$var$load("4SCW2"),
    $bed2818307f017df$var$load("9q75n"),
    $bed2818307f017df$var$load("iYHbd"),
    $bed2818307f017df$var$load("3q2Ng"),
    $bed2818307f017df$var$load("jRpDi"),
    $bed2818307f017df$var$load("5wVuh"),
    $bed2818307f017df$var$load("4NznW"),
    $bed2818307f017df$var$load("gBV5J"),
    $bed2818307f017df$var$load("djjX5"),
    $bed2818307f017df$var$load("c0JsV"),
    $bed2818307f017df$var$load("h3ABO"),
    $bed2818307f017df$var$load("gYQRR"),
    $bed2818307f017df$var$load("4XdkL"),
    $bed2818307f017df$var$load("4eock"),
    $bed2818307f017df$var$load("8k9aB"),
    $bed2818307f017df$var$load("fLwVm"),
    $bed2818307f017df$var$load("6wr18"),
    $bed2818307f017df$var$load("1JF7a"),
    $bed2818307f017df$var$load("Wowvf"),
    $bed2818307f017df$var$load("cX4Bp"),
    $bed2818307f017df$var$load("dawn8"),
    $bed2818307f017df$var$load("ffEVr"),
    $bed2818307f017df$var$load("hhss7"),
    $bed2818307f017df$var$load("aQh37"),
    $bed2818307f017df$var$load("bJVDE"),
    $bed2818307f017df$var$load("1F7LX"),
    $bed2818307f017df$var$load("3QXpo"),
    $bed2818307f017df$var$load("jnVKv"),
    $bed2818307f017df$var$load("7EorR"),
    $bed2818307f017df$var$load("bgHzk"),
    $bed2818307f017df$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.eff4858c.js.map
